import {TypographyIcon} from '@primer/octicons-react'
import {type FilterProvider, FilterProviderType} from '../types'
import {defaultFilterProviderOptions} from '../constants/defaults'

export const RawTextProvider: FilterProvider = {
  type: FilterProviderType.RawText,
  icon: TypographyIcon,
  options: defaultFilterProviderOptions,
  key: 'text',
  priority: 5,
  displayName: 'Text',
  getSuggestions: () => [],
  validateFilterBlockValues: () => [],
  getValueRowProps: () => ({text: ''}),
}
